import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { openCloseContainer } from '../animations/open-close-container.animation';
import { NameFilter } from '@ops/shared-types';
import { rotate } from '../animations/rotate.animation';
import { openClose } from '../animations/open-close.animation';

@Component({
  selector: 'app-finance-dropdown',
  templateUrl: './finance-dropdown.component.html',
  styleUrls: ['./finance-dropdown.component.scss'],
  animations: [rotate, openClose, openCloseContainer],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinanceDropdownComponent {
  @Input() label: string;
  @Input() values: string[] | NameFilter[] = [];
  @Input() value: string | NameFilter;
  @Input() ignoreSort?: boolean;
  @Input() showAddNewOption?: boolean;
  @Input() addNewOptionType?: 'bank-account' | 'credit-card';

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('width') set setWidth(width: number) {
    if (width) {
      this.width = width;
      this.elementRef.nativeElement.style.width = this.width + 'px';
    }
  }
  @Input() isDisabled: boolean;
  @Output() valueChange = new EventEmitter<string | NameFilter>();
  @Output() addNewBankAccount = new EventEmitter<void>();
  @Output() addNewCreditCard = new EventEmitter<void>();
  isOpened = false;

  width: number;
  constructor(private elementRef: ElementRef, private cd: ChangeDetectorRef) {}

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement) {
    const clickedInsideDropdown =
      this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInsideDropdown) {
      this.isOpened = false;
    }
  }

  onClickShader() {
    if (this.isOpened) {
      this.isOpened = false;
    }
  }

  get showAllValue() {
    const allValue = this.values?.filter(
      (value: any) => value.name === 'All' || value === 'All'
    );
    return allValue?.length ? allValue[0] : false;
  }

  onLabelClick() {
    if (this.isDisabled) return;
    this.isOpened = !this.isOpened;
  }

  onSelectorItemClick(value: string | NameFilter) {
    setTimeout(() => {
      this.isOpened = false;
      this.cd.markForCheck();
    }, 0);
    this.valueChange.emit(value);
  }

  onAddNewOptionClick() {
    setTimeout(() => {
      this.isOpened = false;
      this.cd.markForCheck();
    }, 0);
    
    if (this.addNewOptionType === 'bank-account') {
      this.addNewBankAccount.emit();
    } else if (this.addNewOptionType === 'credit-card') {
      this.addNewCreditCard.emit();
    }
  }
}
